export default __webpack_public_path__ + "static/media/emptyTrophy.9ac95c51.svg";